// @flow

import { STATUS_DEFAULT, STATUS_LOADING, STATUS_FAILURE, STATUS_SUCCESS } from 'constants/statusConstants';
import {
  FETCH_YOUTUBE_SPOTLIGHT_START,
  FETCH_YOUTUBE_SPOTLIGHT_SUCCESS,
  FETCH_YOUTUBE_SPOTLIGHT_FAILURE
} from 'actions/ffr-tv/youtubeSpotlightActions';

import { nullYoutubeVideo, type YoutubeVideo } from 'types/YoutubeVideo';
import type { Status } from 'types/Status';
import type { ActionType } from 'types/Actions';

export type State = {
  video: YoutubeVideo,
  status: Status
};

const initialState: State = {
  video: nullYoutubeVideo,
  status: STATUS_DEFAULT
};

export default function(state: State = initialState, action: ActionType): State {
  switch (action.type) {
    case FETCH_YOUTUBE_SPOTLIGHT_START:
      return {
        ...state,
        status: STATUS_LOADING
      };
    case FETCH_YOUTUBE_SPOTLIGHT_SUCCESS:
      return {
        ...state,
        video: action.payload.video,
        status: STATUS_SUCCESS
      };
    case FETCH_YOUTUBE_SPOTLIGHT_FAILURE:
      return {
        ...state,
        status: STATUS_FAILURE
      };
    default:
      return state;
  }
}
